// GENERATED FILE - DO NOT EDIT.
// Source: backend/tests/snapshots/openapi_contract.json, via `npm run gen:api` (orval).
// Regenerate after the API contract changes; `npm run check:gen-api` fails when this is stale.
import * as zod from 'zod';

export const aiModelPatchAuthOneMax = 40;

export const aiModelPatchDisplayNameOneMax = 200;

export const aiModelPatchMaxOutputTokensOneMin = 256;
export const aiModelPatchMaxOutputTokensOneMax = 200000;

export const aiModelPatchModelIdOneMax = 300;

export const aiModelPatchPriceCacheReadOneMin = 0;
export const aiModelPatchPriceCacheReadOneMax = 99999999.9999;

export const aiModelPatchPriceCacheWriteOneMin = 0;
export const aiModelPatchPriceCacheWriteOneMax = 99999999.9999;

export const aiModelPatchPriceInputOneMin = 0;
export const aiModelPatchPriceInputOneMax = 99999999.9999;

export const aiModelPatchPriceOutputOneMin = 0;
export const aiModelPatchPriceOutputOneMax = 99999999.9999;

export const AiModelPatch = zod.object({
  "auth": zod.union([zod.string().max(aiModelPatchAuthOneMax),zod.null()]).optional(),
  "capability": zod.union([zod.enum(['chat', 'embedding']),zod.null()]).optional(),
  "config": zod.union([zod.record(zod.string(), zod.unknown()),zod.null()]).optional(),
  "display_name": zod.union([zod.string().min(1).max(aiModelPatchDisplayNameOneMax),zod.null()]).optional(),
  "enabled": zod.union([zod.boolean(),zod.null()]).optional(),
  "max_output_tokens": zod.union([zod.int().min(aiModelPatchMaxOutputTokensOneMin).max(aiModelPatchMaxOutputTokensOneMax),zod.null()]).optional(),
  "model_id": zod.union([zod.string().min(1).max(aiModelPatchModelIdOneMax),zod.null()]).optional(),
  "price_cache_read": zod.union([zod.number().min(aiModelPatchPriceCacheReadOneMin).max(aiModelPatchPriceCacheReadOneMax),zod.string(),zod.null()]).optional(),
  "price_cache_write": zod.union([zod.number().min(aiModelPatchPriceCacheWriteOneMin).max(aiModelPatchPriceCacheWriteOneMax),zod.string(),zod.null()]).optional(),
  "price_input": zod.union([zod.number().min(aiModelPatchPriceInputOneMin).max(aiModelPatchPriceInputOneMax),zod.string(),zod.null()]).optional(),
  "price_output": zod.union([zod.number().min(aiModelPatchPriceOutputOneMin).max(aiModelPatchPriceOutputOneMax),zod.string(),zod.null()]).optional(),
  "sort_order": zod.union([zod.int(),zod.null()]).optional()
});

export type AiModelPatch = zod.input<typeof AiModelPatch>;
export type AiModelPatchOutput = zod.output<typeof AiModelPatch>;
